import { FunctionComponent, useState } from "react";
import { Navbar, Nav, Table, Dropdown } from "react-bootstrap";
import { ReactComponent as Logo } from "../../assets/images/logo.svg";
import { ReactComponent as EverscaleLogo } from "../../assets/images/svg/everscale.svg";
import { Link, useLocation } from "react-router-dom";
import styles from "./Header.module.scss";
import stylesButton from "../form/Input.module.scss";
import classnames from "classnames/bind";
import { Button, Icon } from "../../components";

const cn = classnames.bind(styles);

const MediumIcon = () => (<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.6407 6.3208C10.756 6.3208 13.2812 8.86366 13.2812 12.0002C13.2812 15.1368 10.7558 17.6794 7.6407 17.6794C4.52561 17.6794 2 15.1368 2 12.0002C2 8.86366 4.52542 6.3208 7.6407 6.3208ZM16.6485 6.65349C18.2061 6.65349 19.4688 9.04705 19.4688 12.0002C19.4688 14.9526 18.2063 17.3469 16.6487 17.3469C15.091 17.3469 13.8283 14.9526 13.8283 12.0002C13.8283 9.04782 15.0908 6.65349 16.6485 6.65349ZM21.0081 7.21039C21.5558 7.21039 22 9.35483 22 12.0002C22 14.6448 21.556 16.79 21.0081 16.79C20.4602 16.79 20.0163 14.6454 20.0163 12.0002C20.0163 9.35502 20.4604 7.21039 21.0081 7.21039Z" fill="currentColor"/>
</svg>
);

export const Header: FunctionComponent = ({...props}) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const location:string = useLocation().pathname.split('/').filter(Boolean)[0];

  return (
    <header className={cn("header")}>
      <Navbar expand="sm" expanded={expanded} className={cn("navbar")}>
      <Navbar.Brand className={cn("navbar-brand")}><Nav.Link href="http://ever.surf" onClick={() => setExpanded(false)} className="logo"><span>{location === "token" ? "Token" : "Ever"} <Logo/> Surf</span></Nav.Link><span
                className={cn("logo-everscale", "paragraph paragraph-small")}
              >
                from <EverscaleLogo /> Everscale founders
              </span></Navbar.Brand>


      {location === "token" && <Nav.Link href="https://eversurf.medium.com/ever-surf-light-paper-3c74cf39bcc1" rel="noreferrer" target="_blank" className={cn("nav-link", "nav-link-medium")}>{<Button type={"button"} size={"large"} color="default" iconLeft={{icon: <Icon icon="medium" />, animation: "none"}}>Lightpaper</Button>}</Nav.Link>}
      </Navbar>
    </header>
  );
};

export default Header;
